import { render, staticRenderFns } from "./RemoveGroup.vue?vue&type=template&id=6e433acc&scoped=true&"
import script from "./RemoveGroup.vue?vue&type=script&lang=js&"
export * from "./RemoveGroup.vue?vue&type=script&lang=js&"
import style0 from "./RemoveGroup.vue?vue&type=style&index=0&id=6e433acc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e433acc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e433acc')) {
      api.createRecord('6e433acc', component.options)
    } else {
      api.reload('6e433acc', component.options)
    }
    module.hot.accept("./RemoveGroup.vue?vue&type=template&id=6e433acc&scoped=true&", function () {
      api.rerender('6e433acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/RemoveGroup.vue"
export default component.exports